import { render } from "./AttachmentVideoPlayer.vue?vue&type=template&id=3d9b13ea&scoped=true"
import script from "./AttachmentVideoPlayer.vue?vue&type=script&lang=js"
export * from "./AttachmentVideoPlayer.vue?vue&type=script&lang=js"

import "./AttachmentVideoPlayer.vue?vue&type=style&index=0&id=3d9b13ea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9b13ea"]])

export default __exports__